/**
 * Input Schema of Faturamento
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'
import SearchResponsavel from '@/components/SearchResponsavel.vue'
import {NotasInseridasConfiguracao} from '@/model/resource/NotasInseridasConfiguracao'

export class InputNotasInseridasSchema extends Schema {
  collectionResponsavel = new ResponsavelCollection().noPagination()

  formFields = ['ehGrupoEconomico', 'ativo']

  readonly name = 'InputNotasInseridasConfiguracao'

  readonly fieldSet: FieldSet<NotasInseridasConfiguracao> = {
    responsavel: (schema): FieldComponent => ({
      is: SearchResponsavel,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'col-span-2',
        collection: this.collectionResponsavel,
        noResultLabel: this.translateFrom('noResultLabel'),
        noOptionsLabel: this.translateFrom('noOptionsLabel'),
        required: true,
      },
    }),
    ehGrupoEconomico: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8 col-span-2',
        labelClass: 'relative state',
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
  }
}
